// Map contract errors + wallet errors to human-readable messages
const ERROR_MAP = {
  OnlyOwner: 'Only owner can perform this action',
  OnlyOwnerOrAdmin: 'Only admin can perform this action',
  AlreadyRegistered: 'This wallet is already registered',
  NotRegistered: 'Wallet not registered. Please register first.',
  InvalidPackage: 'Invalid package selected',
  AlreadyActive: 'This package is already active',
  PreviousNotActive: 'Please activate the previous package first',
  UserIsBlocked: 'This account has been blocked',
  NoIncomeToClaim: 'No income available to claim',
  InvalidLevel: 'Invalid matrix level',
  InvalidWallet: 'Invalid wallet address',
  HeldInsufficient: 'Held bucket amount insufficient for upgrade',
  MaxPackageReached: 'You have already activated the maximum package',
  PackageNotActive: 'This package is not active for the user',
  LengthMismatch: 'Batch array lengths do not match',
  TransferFailed: 'Token transfer failed. Check USDT balance and allowance.',
  InsufficientRouterPool: 'Router pool has insufficient funds'
};

export const parseError = (error) => {
  if (!error) return 'Unknown error occurred';

  // User rejected transaction
  if (error.code === 4001 || error.code === 'ACTION_REJECTED') {
    return 'Transaction rejected by user';
  }

  // Insufficient funds
  if (error.code === 'INSUFFICIENT_FUNDS' || (error.message || '').includes('insufficient funds')) {
    return 'Insufficient BNB balance for gas fees';
  }

  // Network error
  if (error.code === 'NETWORK_ERROR' || (error.message || '').includes('network')) {
    return 'Network error. Please check your connection.';
  }

  // Try to extract custom error name
  const msg = error.reason || error.data?.message || error.message || '';

  // Match custom error like "execution reverted: NotRegistered()"
  for (const key of Object.keys(ERROR_MAP)) {
    if (msg.includes(key)) return ERROR_MAP[key];
  }

  // Match "execution reverted: <text>"
  const revertMatch = msg.match(/execution reverted:?\s*(.+?)(?:"|$)/i);
  if (revertMatch && revertMatch[1]) {
    const revertReason = revertMatch[1].trim();
    if (ERROR_MAP[revertReason]) return ERROR_MAP[revertReason];
    return revertReason;
  }

  // Contract errors nested in error.error.data
  if (error.error?.data?.originalError?.data) {
    const errData = error.error.data.originalError.data;
    for (const key of Object.keys(ERROR_MAP)) {
      if (errData.includes(key)) return ERROR_MAP[key];
    }
  }

  // Fallback: return first sentence of the message
  if (msg) {
    const shortMsg = msg.split('\n')[0].split('(')[0].trim();
    if (shortMsg.length < 150) return shortMsg;
  }

  return 'Transaction failed. Please try again.';
};
